// eslint-disable-next-line import/no-anonymous-default-export
export default
[
    {title: "TransferBalances.Label.carNumber", dataIndex: "carNumber", key: "carNumber", responsive: ['md']},
    {title: "TransferBalances.Label.carBalance", dataIndex: "balance", key: "balance", responsive: ['md']},
    {title: "TransferBalances.Label.consumptionValue", dataIndex: "consumptionValue", key: "consumptionValue", responsive: ['md']},
]  

